<template>
    <div >   <a-drawer
            :title='title'
            :visible="visible"
            v-bind="drawerConfig"
            :body-style="{ paddingBottom: '80px' }"
            @close="onClose"
            class="boxs"
    >
        <a-form-model ref="ruleForm" :model="form" :rules="rules" v-bind="layout" :colon="false">

                        <a-form-model-item
                                class="citem citema"
                                ref="start_time"
                                label="运营时间"
                                :labelCol="{span:9}"
                                prop="start_time"
                                :help="formErr.start_time"
                                :validateStatus='!formErr.start_time||formErr.start_time==""?"":"error"'
                                style="position: relative"
                        >
                            <a-input-number :min="1" :max="9999" class="inputNum"   v-model="form.start_time"  @change="(e) => { formErr.start_time='' ;}"
                                            :precision="0" />
<!--                            @blur="(e) => {  form.start_time = e.target.value.trim();form.start_time = e.target.value.replace(/^(0+)|[^\d]/g, '') }"-->
                            <span class="fg">—</span>
                        </a-form-model-item>
                        <a-form-model-item
                                class="citem"
                                ref="end_time"
                                label=" "
                                :labelCol="{span:0 }"
                                prop="end_time"
                                :help="formErr.end_time"
                                :validateStatus='!formErr.end_time||formErr.end_time==""?"":"error"'
                        >
                            <a-input-number :min="1" :max="9999" class="inputNum"    v-model="form.end_time"  @change="(e) => { formErr.end_time=''  }"
                                            :precision="0"  />
<!--                            @blur="(e) => {  form.end_time = e.target.value.trim();form.end_time = e.target.value.replace(/^(0+)|[^\d]/g, '') }"-->
                            <span style="position: absolute;top: -10px;right: -20px">天</span>
                        </a-form-model-item>

            <a-form-model-item
                    class="citem  "
                    ref="uv"
                    label="UV标准值"
                    :labelCol="{span:9}"
                    prop="uv"
                    :help="formErr.uv"
                    :validateStatus='!formErr.uv||formErr.uv==""?"":"error"'
            >
                <a-input-number :min="1" :max="999999" class="inputNum"   v-model="form.uv"  @change="(e) => { formErr.uv='' ;}"
                                :precision="0" />
<!--                @blur="(e) => {  form.uv = e.target.value.trim();form.uv = e.target.value.replace(/^(0+)|[^\d]/g, '') }"-->
            </a-form-model-item>
            <a-form-model-item
                    class="citem citemb "
                    :labelCol="{span:9}"
                    ref="status"
                    label="状态"
                    prop="status"
                    :extra="formErr.status"
                    :validateStatus='!formErr.status||formErr.status==""?"":"error"'
            >
            <a-radio-group v-model="form.status"  >
                <a-radio :value="1"> 启用 </a-radio>
                <a-radio :value="0"> 停用 </a-radio>
            </a-radio-group>
            </a-form-model-item>
        </a-form-model>
        <div class="drawer-btn"  >

            <a-button type="primary" @click="onSubmit" :style="{ marginRight: '8px' }">
                确定
            </a-button>
            <a-button @click="onClose">
            取消
        </a-button>
        </div>
    </a-drawer></div>
</template>

<script>
    import {submitForm,drawerConfig,validator} from "../../../../utils/utils"
    import API from "../api";
    export default {
        name: "uvForm",
        props: ["visible","title","editId"],
        data() {
            let validator2=(rule, value, callback,errval)=> {
                let formerrname=rule.field
                // alert(this.form.end_time*1<this.form.start_time)
                // console.log("start",this.form.end_time*1<this.form.start_time*1)
                this.formErr={   status:"", end_time:"", start_time:"",  uv:""}
                if( errval!=""){
                    callback(new Error(errval))
                } else if(this.form.end_time*1<this.form.start_time*1&&this.form.end_time!=""&&this.form.end_time!=null){
                    this.formErr.end_time=""
                    this.formErr.start_time="开始时间不能大于起始时间"
                    callback( )
                }else if(this.form.end_time*1==this.form.start_time*1&&this.form.end_time!=""&&this.form.end_time!=null){
                    this.formErr.end_time=""
                    this.formErr.start_time=""
                    this.formErr.start_time="开始时间与结束时间不能相同"
                    callback( )
                }else if(this.form.end_time==""||this.form.end_time==null){
                    this.formErr.end_time="请输入结束时间"
                    callback()
                } else if(this.form.end_time*1<=this.form.start_time*1&&this.form.end_time!=""&&this.form.end_time!=null){
                    // alert(this.form.end_time)
                    this.formErr.start_time=""
                    this.formErr.end_time="结束时间不能小于起始时间"
                    callback( )
                } else{
                    this.formErr.end_time=""
                    this.formErr.start_time=""
                    callback();}
            }
            let validator3=(rule, value, callback,errval)=> {
                let formerrname=rule.field
                // console.log("start",this.form.end_time*1==this.form.start_time*1&&this.form.end_time!=""&&this.form.end_time!=null)
                if( errval!=""){
                    callback(new Error(errval))
                }else if(this.form.end_time==""||this.form.end_time==null){
                    this.formErr.end_time="请输入结束时间"
                    callback()
                } else if(this.form.end_time*1<this.form.start_time*1&&this.form.end_time!=""&&this.form.end_time!=null){
                    // alert(this.form.end_time)
                    this.formErr.start_time=""
                    this.formErr.end_time="结束时间不能小于起始时间"
                    callback( )
                }else if(this.form.end_time*1<this.form.start_time*1&&this.form.end_time!=""&&this.form.end_time!=null){
                    this.formErr.end_time=""
                    this.formErr.start_time="开始时间必须大于起始时间"
                    callback( )
                }else if(this.form.end_time*1==this.form.start_time*1&&this.form.end_time!=""&&this.form.end_time!=null){

                    this.formErr.end_time=""
                    this.formErr.start_time="开始时间与结束时间不能相同"
                    callback( )
                } else{
                    this.formErr.end_time=""
                    this.formErr.start_time=""
                    callback();}
            }
            return {
                drawerConfig ,
                form: {
                    status:1,
                    end_time:"",
                    start_time:"",
                    uv:""
                },
                formErr: {
                    status:"",
                    end_time:"",
                    start_time:"",
                    uv:""
                },
                rules: {
                    start_time: [{required: true, message: "请输入开始时间 ", trigger: "blur"},{validator:(rule, value, callback)=>{validator2(rule, value, callback,this.formErr.start_time)}  , trigger: "blur"  }, ],
                    end_time: [{validator:(rule, value, callback)=>{validator3(rule, value, callback,this.formErr.end_time)}, trigger: "blur"  }, ],
                    uv: [{required: true, message: "请输入UV ", trigger: "blur"} ,{validator:(rule, value, callback)=>{validator(rule, value, callback,this.formErr.uv)}  , trigger: "blur"  },],
                },
                layout: {
                    labelCol: { span: 4 },
                    wrapperCol: { span: 14},
                },
            };
        },
        watch:{
            editId: function (a, b) {
                if (a != "") {
                    API.service. EDIT_DATA({id: a}).then(res => {
                        let val = res.data.data.info
                        this.form = val
                    })
                } else {
                    this.form.id = ''
                }
            }
        },
        methods: {
            onClose() {
                this.$emit("changVisible", false);
                this.formErr={   status:"",
                    end_time:"",
                    start_time:"",
                    uv:""}
                this.$refs.ruleForm.resetFields();
            },
            onSubmit() {
                let _this = this;
                this.$refs.ruleForm.validate(valid => {
                    if (valid) {
                        let url
                        this.formErr.end_time=""
                        this.formErr.start_time=""
                        this.form.id == '' || this.form.id == undefined ? url = API.service.SUBMIT_ADD : url = API.service.SUBMIT_EDIT
                        submitForm(url, _this.form).then(res => {
                            if (res == true) {
                                this.onClose()
                            } else {
                                res.map((item, index) => {
                                    this.formErr[item.field] = item.msg
                                })
                            }
                        })
                    } else {
                        return false;
                    }
                });
            },
        },
    }
</script>

<style scoped>
.citem{display: inline-block;width: 49%}
    .inputNum{width: 170px;display: inline-block}
    .fg{position: relative;left:10px;top: -2px}
    .citemb{display: block}
.boxs >>>.ant-form-explain, .ant-form-extra{width:350px!important;}
.boxs >>> .has-error .ant-form-explain{width:350px!important;}
.boxs >>> .has-error .ant-form-split{width:350px!important;}
.ant-form-item-required {display: none!important;}

</style>
